"use client";

import { c as _c } from "react/compiler-runtime";
import { usePageViewTracking } from "@/hooks/tracking/page-view/use-page-view-tracking.hook";
import { TrackPageView } from "./TrackPageView.component";
export function TrackPageViewContainer() {
  const $ = _c(1);
  usePageViewTracking();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TrackPageView key="archive" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}